import { getTileImage } from "~/composables/tools";

export function useColorSwatch() {
  function getBackgroundCSS(color: { image?: string }) {
    const url = getTileImage({
      image: color.image,
      width: 90,
      height: 90,
    });
    return url ? `url(${url})` : "none";
  }

  function getSwatchStyle(color: { hex?: string; image?: string }) {
    const bgImage = getBackgroundCSS(color);
    if (bgImage !== "none") {
      return { backgroundImage: bgImage };
    }
    if (color.hex) {
      return { backgroundColor: color.hex };
    }
    return { backgroundImage: "none" };
  }

  return { getBackgroundCSS, getSwatchStyle };
}
